import React from 'react';

export const StreamingIndicator: React.FC = () => {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-600 py-2">
      <div className="flex gap-1">
        <div 
          className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" 
          style={{ animationDelay: '0ms' }}
        ></div>
        <div 
          className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" 
          style={{ animationDelay: '150ms' }}
        ></div>
        <div 
          className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" 
          style={{ animationDelay: '300ms' }}
        ></div>
      </div>
      <span>Loading more recommendations...</span>
    </div>
  );
};

